"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    LargeTitle: function() {
        return _LargeTitle.LargeTitle;
    },
    largeTitleClassNames: function() {
        return _useLargeTitleStylesstyles.largeTitleClassNames;
    }
});
const _LargeTitle = require("./LargeTitle");
const _useLargeTitleStylesstyles = require("./useLargeTitleStyles.styles");
